import {NetworkNode} from "../../../../../../services/back/infrastructure-schema.service";

export function separateNetworks(
	connectedNetworks: NetworkNode[],
): {
	intercoNetworks: NetworkNode[],
	standardNetworks: NetworkNode[]
} {
	// Initialisation des tableaux de résultats
	const standardNetworks: NetworkNode[] = [];
	const intercoNetworks: NetworkNode[] = [];

	// Parcours et séparation des réseaux
	for (const networkNode of connectedNetworks) {
		if (networkNode.network.network.role !== "intercommunication") {
			// Réseau standard
			standardNetworks.push(networkNode);
		} else {
			// Réseau d'intercommunication
			intercoNetworks.push(networkNode);
		}
	}

	// Retourne un objet avec les deux types de réseaux
	return {
		standardNetworks,
		intercoNetworks
	};
}

export function removeEmptyIntercoNetwork(
	network: Array<NetworkNode>
): NetworkNode[] {
	let count: number = 0;

	if (network.length > 0) {
		if ( network[0].connectedRouters.length > 0 ) {
			for (let i = 0; i < network[0].connectedRouters.length; i++) {
				if (network[0].connectedRouters[i].router.type != "router" || network[0].connectedRouters[i].router.type != "firewall") {
					count++
				}
			}
		}
	}

	if (count > 0) {
		return network;
	} else {
		return []
	}
}
